import { DisplayName } from '@99designs/common/components/DisplayName';
import { spaces } from '@99designs/common/core/settings';
import * as React from 'react';
import styled from 'styled-components';
import Avatar from './Avatar';
import AvatarCollection from './AvatarCollection';
import { Designer } from './User';

interface Props {
    users: Designer[];
}

const StyledHeaderUserLayout = styled.div`
    display: flex;
`;

const Label = styled.div`
    margin: auto ${spaces.space4}px auto 0px;
`;

const DesignerName = styled.div`
    text-align: left;
    margin: auto ${spaces.space4}px;
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const HeaderUserLayout = ({ users }: Props) => (
    <StyledHeaderUserLayout data-test-id="header-user-layout">
        <Label>{__('with')}</Label>
        {users.length === 1 ? (
            <Avatar userId={users[0].id} variations={['small', 'white-border']} />
        ) : (
            <AvatarCollection users={users} size={'small'} limit={7} />
        )}
        <DesignerName>
            {users.length === 1 && (
                <DisplayName
                    user={{
                        name: users[0].displayName,
                        profileUrl: `/profiles/${users[0].id}`,
                    }}
                    isLinked={false}
                />
            )}
        </DesignerName>
    </StyledHeaderUserLayout>
);

export default HeaderUserLayout;
